import validate from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import main_45global from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/middleware/main.global.js";
export const globalMiddleware = [
  validate,
  main_45global
]
export const namedMiddleware = {}